import React from "react";
import SectionTitle from "../SectionTitle/SectionTitle";

const NetworkingSection = () => {
  const networkingFeatures = [
    {
      number: "01",
      badgeColor: "#252686",
      icon: "fa fa-users",
      iconColor: "#252686",
      title: "Dedicated Networking Lounge",
      description: "A separate networking zone inside the venue. Meet business owners, investors, professionals & founders.",
    },
    {
      number: "02",
      badgeColor: "#25D366",
      icon: "fa fa-whatsapp",
      iconColor: "#25D366",
      title: "Industry-Wise WhatsApp Groups",
      description: "Exclusive post-event networking groups for: MSME Manufacturing, Exporters, Traders, Consulting Professionals, and Startups.",
    },
  ];

  return (
    <section
      className="section-padding"
      style={{
        background: "#2D2163",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background Numbers */}
      <div
        style={{
          position: "absolute",
          left: "-50px",
          top: "50%",
          transform: "translateY(-50%)",
          fontFamily: "DM Sans, sans-serif",
          fontSize: "200px",
          fontWeight: 700,
          color: "rgba(255, 255, 255, 0.05)",
          zIndex: 0,
          pointerEvents: "none",
        }}
      >
        01
      </div>
      <div
        style={{
          position: "absolute",
          right: "-50px",
          top: "50%",
          transform: "translateY(-50%)",
          fontFamily: "DM Sans, sans-serif",
          fontSize: "200px",
          fontWeight: 700,
          color: "rgba(255, 255, 255, 0.05)",
          zIndex: 0,
          pointerEvents: "none",
        }}
      >
        02
      </div>

      <div className="container" style={{ position: "relative", zIndex: 1 }}>
        <div className="row justify-content-center">
          <div className="col-12">
            <SectionTitle
              title="High-Value Networking Opportunities"
              titleStyle={{ color: "#FFFFFF" }}
              paragarap="Because real connections create real growth."
              paragraphStyle={{ color: "#FFFFFF" }}
            />
          </div>
        </div>

        <div className="services-wrap">
          <div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
            {networkingFeatures.map((feature, index) => (
              <div
                key={index}
                className="col col-xl-6 col-lg-6 col-md-6 col-12"
                style={{ display: "flex" }}
              >
                <div
                  className="services-card"
                  style={{
                    background: "#FFFFFF",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    padding: "40px 30px",
                    position: "relative",
                    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                    borderRadius: "15px",
                    marginBottom: "30px",
                  }}
                >
                  {/* Icon */}
                  <div style={{ marginBottom: "25px" }}>
                    <i
                      className={feature.icon}
                      style={{
                        fontSize: "60px",
                        color: feature.iconColor,
                      }}
                    ></i>
                  </div>

                  {/* Title */}
                  <h2
                    style={{
                      fontSize: "22px",
                      fontWeight: 700,
                      color: "#000B47",
                      marginBottom: "20px",
                      lineHeight: "1.3",
                    }}
                  >
                    {feature.title}
                  </h2>

                  {/* Description */}
                  <p
                    style={{
                      fontSize: "16px",
                      color: "#525252",
                      lineHeight: "1.6",
                      marginBottom: 0,
                    }}
                  >
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Quote Card */}
        <div className="row">
          <div className="col-12">
            <div
              className="services-card"
              style={{
                background: "#FFFFFF",
                borderRadius: "15px",
                padding: "30px",
                textAlign: "center",
                marginTop: "20px",
                boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
                borderLeft: "4px solid #F2BC00",
              }}
            >
              <p style={{ margin: 0, fontSize: "18px", fontWeight: "500", color: "#333", fontStyle: "italic" }}>
                <i className="fa fa-quote-left" style={{ marginRight: "10px", color: "#F2BC00" }}></i>
                Participants consistently tell us that networking is the most valuable part of the Summit.
                <i className="fa fa-quote-right" style={{ marginLeft: "10px", color: "#F2BC00" }}></i>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NetworkingSection;

